<script>
  import Layout from '/components/Layout.svelte';
  import DiagnosticTable from '/components/DiagnosticTable.svelte';
  import { inertia } from '@inertiajs/svelte';

  export let invalid_by_type = {};
  export let total_files = 0;

  $: types = Object.keys(invalid_by_type).sort();
  $: isEmpty = types.length === 0;

  function typeLabel(t) {
    return t.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  }

  function tableRows(rows) {
    return rows.map(r => ({ path: r.editor_path, cells: r }));
  }
</script>

<svelte:head>
  <title>Invalid YAML Syntax — Diagnostics</title>
</svelte:head>

<Layout title="Invalid YAML Syntax">
  <div class="toolbar">
    <a use:inertia href="/" class="back-link">← Dashboard</a>
  </div>

  {#if isEmpty}
    <div class="all-clear">
      <span class="all-clear-icon">✓</span>
      All YAML files parse without errors.
    </div>
  {:else}
    <p class="summary">
      {total_files} {total_files === 1 ? 'file' : 'files'} contain invalid YAML syntax.
    </p>

    {#each types as type}
      {@const rows = invalid_by_type[type]}
      <DiagnosticTable
        title={typeLabel(type)}
        count="{rows.length} {rows.length === 1 ? 'file' : 'files'}"
        headers={['File', 'Parse error']}
        rows={tableRows(rows)}
        filename="invalid_yaml_{type}"
      >
        {#each rows as row}
          <tr>
            <td class="source-cell">
              <a use:inertia href="/editor/{type}/{row.editor_path}" class="event-link">{row.path}</a>
            </td>
            <td class="error-cell">
              <span class="error-text">{row.error}</span>
            </td>
          </tr>
        {/each}
      </DiagnosticTable>
    {/each}
  {/if}
</Layout>

<style>
  .toolbar {
    display: flex;
    margin-bottom: 1.5rem;
  }

  .back-link {
    color: #64748b;
    text-decoration: none;
    font-size: 0.9rem;
  }

  .back-link:hover { color: #1e293b; }

  .summary {
    font-size: 0.9rem;
    color: #64748b;
    margin: 0 0 1.5rem 0;
  }

  .all-clear {
    display: flex;
    align-items: center;
    gap: 0.625rem;
    padding: 1.25rem 1.5rem;
    background: #f0fdf4;
    border: 1px solid #86efac;
    border-radius: 0.75rem;
    color: #166534;
    font-weight: 600;
  }

  .all-clear-icon { font-size: 1.1rem; }

  .error-cell {
    max-width: 60ch;
  }

  .error-text {
    font-family: 'Fira Code', monospace;
    font-size: 0.8rem;
    color: #991b1b;
    word-break: break-word;
  }
</style>
